var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-bar'),_c('Loading'),_c('div',[_c('iframe',{staticClass:"frame-custom",staticStyle:{"width":"100%"},attrs:{"frameborder":"no","scrolling":"","allowfullscreen":"true","src":this.gameData.gameurl}})]),_c('mobile-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }